



















import { Vue, Component, Prop } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { IRecipient } from '@signing-page/documents/types/recipient';

@Component({
  components: {
    Input,
  },
})
export default class AfterSignCreateSignup extends Vue {
  @Prop() recipient: IRecipient;
  @Prop() error?: string;
  @Prop() didYouMean?: string;

  emailInput = '';

  created() {
    this.emailInput = this.recipient.email || '';
  }

  get errorMessage(): string {
    if (this.didYouMean) {
      return `${this.$t('email-error-did-you-mean')}: ${this.didYouMean}`;
    }
    if (this.error === 'Unreachable') {
      return `${this.$t('could-not-verify-email-address')}`;
    }
    return this.$t('could-not-sign-up').toString();
  }

  handleInput() {
    this.$emit('email', this.emailInput);
  }
}
